export default class AnimalImageAnimation {
    constructor($el) {
        this.$el = $el;
        this.$container = this.$el.closest('[data-animal-list]');
        this.startOffset = 160;
        this.endOffset = -40;
        this.mediaQuery = window.matchMedia('(min-width: 992px)');
        this.ticking = false;

        this.update = this.update.bind(this);
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);

        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onResize);

        this.update();
    }

    getRect() {
        if (!this.$container) {
            return null;
        }

        return this.$container.getBoundingClientRect();
    }

    easeOutCubic(progress) {
        return 1 - Math.pow(1 - progress, 3);
    }

    getProgress() {
        const rect = this.getRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        if (!rect) {
            return 1;
        }

        const startTrigger = viewportHeight * 0.7;
        const endTrigger = -rect.height;
        const progress = (startTrigger - rect.top) / (startTrigger - endTrigger);

        return Math.min(Math.max(progress, 0), 1);
    }

    update() {
        if (!this.mediaQuery.matches) {
            this.$el.style.transform = 'translateY(0)';
            this.ticking = false;
            return;
        }

        const progress = this.getProgress();
        const easedProgress = this.easeOutCubic(progress);
        const yOffset = this.startOffset + ((this.endOffset - this.startOffset) * easedProgress);

        this.$el.style.transform = `translateY(${yOffset}px)`;
        this.ticking = false;
    }

    onScroll() {
        if (this.ticking) {
            return;
        }

        this.ticking = true;
        window.requestAnimationFrame(this.update);
    }

    onResize() {
        this.update();
    }

    destroy() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
    }
}
